module.exports = __webpack_public_path__ + "img/conocenos1.41e3091e.webp";